// Property type factories used to build appearance editors
import { StrokeType, FillType } from "../PropertyTypes";

// Formas (Shapes) category - includes geometric shape drawing tools
const formasRegistry = {
  displayName: "Formas",
  interactives: {
    rectangle: {
      displayName: "Retângulo",
      key: "rectangle",
      icon: "Shape_Rectangle",
      propName: "rectangles",
      component: "Rectangle",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#2196F3", opacity: 0.2 },
        }),
      ],
    },
    ellipse: {
      displayName: "Elipse",
      key: "ellipse",
      icon: "Shape_Elipse",
      propName: "ellipses",
      component: "Ellipse",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#2196F3", opacity: 0.2 },
        }),
      ],
    },
    heart: {
      displayName: "Coração",
      key: "heart",
      icon: "Shape_Heart",
      propName: "hearts",
      component: "Heart",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FF4081",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#FF4081", opacity: 0.6 },
        }),
      ],
    },
    star: {
      displayName: "Estrela",
      key: "star",
      icon: "Shape_Star",
      propName: "stars",
      component: "Star",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#FFD700",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#FFD700", opacity: 0.6 },
        }),
      ],
    },
    check: {
      displayName: "Check",
      key: "check",
      icon: "Shape_Check",
      propName: "checks",
      component: "Check",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#4CAF50",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#4CAF50", opacity: 0.6 },
        }),
      ],
    },
    cross: {
      displayName: "Cruz",
      key: "cross",
      icon: "Shape_Cross",
      propName: "crosses",
      component: "Cross",
      defaultOptionsForAppearance: [
        StrokeType({
          name: "stroke",
          displayName: "Cor da Linha",
          defaultValue: {
            color: "#2196F3",
            dash: "Solid",
            width: 2,
            opacity: 1,
          },
        }),
        FillType({
          name: "fill",
          displayName: "Preenchimento",
          defaultValue: { color: "#2196F3", opacity: 0.6 },
        }),
      ],
    },
  },
};

export default formasRegistry;
